export const defaultDialogConfig = {
  width: '100%',
  maxWidth: '1110px',
  panelClass: 'zero-padding-dialog-container',
  backdropClass: 'default-backdrop-overlay',
};
